import axios from 'axios';

export function setAuthToken(token) {
  axios.defaults.headers.common['Authorization'] = '';
  delete axios.defaults.headers.common['PortalToken'];

  if (token) {
    axios.defaults.headers.common['PortalToken'] = `${token}`;
  }
}